module.exports = __webpack_public_path__ + "img/android.9759870b.svg";